import { render, staticRenderFns } from "./InformationPlates.vue?vue&type=template&id=64121f43&"
import script from "./InformationPlates.vue?vue&type=script&lang=js&"
export * from "./InformationPlates.vue?vue&type=script&lang=js&"
import style0 from "./InformationPlates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports